import React, { useCallback, useState } from 'react'
import { useTheme } from 'styled-components/native'
import Typography from 'APP/Converse/Typography'
import Icon from 'APP/Converse/Icon'

import { MemberTaskBarProps } from '../types'
import { ElevationWrapper, Container, HeaderContainer, HeaderLeft, ItemsScrollView } from './styles'
import Collapsible from 'react-native-collapsible'

import MemberTaskBarItem from '../MemberTaskBarItem'
import I18n from 'APP/I18n'

const MemberTaskBar: React.FC<MemberTaskBarProps> = ({ tasks, testID = 'MEMBER_TASK_BAR' }) => {
  const theme = useTheme()
  const [isExpanded, setIsExpanded] = useState(false)

  const toggleExpanded = useCallback(() => {
    setIsExpanded((prev) => !prev)
  }, [])

  if (tasks.length === 0) return null

  const taskItems = tasks.map((task) => <MemberTaskBarItem key={task.id} task={task} />)

  /**
   * If there is only one task, simply show it without the Header and the Collapsible
   */
  if (tasks.length === 1)
    return (
      <ElevationWrapper>
        <Container testID={testID}>{taskItems}</Container>
      </ElevationWrapper>
    )

  return (
    <ElevationWrapper>
      <Container testID={testID}>
        <HeaderContainer
          onPress={toggleExpanded}
          accessibilityRole="button"
          accessibilityState={{ expanded: isExpanded }}
          accessibilityLabel={I18n.t('MemberTaskBar.title')}
          testID={`${testID}_HEADER`}
        >
          <HeaderLeft>
            <Typography variant="subheaderBold">{I18n.t('MemberTaskBar.title')}</Typography>
          </HeaderLeft>

          <Icon
            src={isExpanded ? 'keyboard-arrow-up' : 'keyboard-arrow-down'}
            variant="materialIcons"
            size={theme.metrics.icon.small}
            color="accent"
          />
        </HeaderContainer>

        <Collapsible collapsed={!isExpanded}>
          <ItemsScrollView testID={`${testID}_ITEMS`}>{taskItems}</ItemsScrollView>
        </Collapsible>
      </Container>
    </ElevationWrapper>
  )
}

export default MemberTaskBar
